import { TaxonomyClass } from "modules/TaxonomyModule/consts";

export const UNKNOWN_PREMATCH_CLASS = "Unknown";
export type PrematchTaxonomyClasses =
  | TaxonomyClass.MEDICAL_PRODUCT
  | TaxonomyClass.FOOD_PRODUCT
  | TaxonomyClass.RETAIL_PRODUCT
  | TaxonomyClass.DIAGNOSTIC_TEST
  | typeof UNKNOWN_PREMATCH_CLASS;
